<template>
  <button type="button" class="button" :disabled="disabled" @click="handleClick">
    <span class="button__icon"><slot name="icon" /></span>
    <span class="button__text">
      <slot />
      <span v-if="$slots.desc" class="button__text-desc"><slot name="desc" /></span>
    </span>
  </button>
</template>

<script setup lang="ts">
  const emits = defineEmits(['buttonClick']);
  defineProps<{
    disabled?: boolean;
  }>();

  const handleClick = () => {
    emits('buttonClick');
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .button {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    align-items: center;
    justify-content: center;
    gap: 1.5625vw;
    width: 100%;
    height: 100%;
    padding: 1.5625vw;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 1.5625vw;
    &[disabled] {
      cursor: not-allowed;
      opacity: 0.5;
    }
    @media (max-width: vars.$sm) {
      grid-template-columns: auto 1fr;
      grid-template-rows: 1fr;
      justify-content: flex-start;
      gap: 10px;
      padding: 10px 20px;
      border-radius: 20px;
    }

    .button__icon ::v-deep(img) {
      width: 60%;
      @media (max-width: vars.$sm) {
        width: auto;
        height: 60px;
      }
    }
    .button__text {
      display: grid;
      grid-template-rows: auto auto;
      font-size: 2.0896vw;
      font-weight: 500;
      @media (max-width: vars.$sm) {
        font-size: 20px;
      }

      .button__text-desc {
        font-size: 1.5625vw;
        @media (max-width: vars.$sm) {
          font-size: 16px;
        }
      }
    }
  }
</style>
